











































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { storeSupervisiLimbah } from "@/store/modules/SupervisiLimbahStore";
import SupervisiLimbahSvc from "@/services/SupervisiLimbahService";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";
import {
  SupervisiLimbah,
  SupervisiLimbahListFilter
} from "@/types/SupervisiLimbah";

@Component({ components: { VCDateTimePicker } })
export default class SupervisiLimbahListPage extends Vue {
  filter = {
    tanggal_dari: "",
    tanggal_sampai: "",
    signed: null as boolean | null
  };

  signedOpts = [
    { text: "Sudah TTD lengkap", value: true },
    { text: "Belum final", value: false }
  ];

  pagination = {
    page: 1,
    itemsPerPage: 15
  };

  headers = [
    { text: "Nomor Formulir", value: "nomor_formulir", sortable: false },
    { text: "Tanggal", value: "tanggal_supervisi", sortable: false },
    { text: "IPCN", value: "supervisor", sortable: false },
    { text: "Koordinator", value: "koordinator", sortable: false },
    { text: "Status", value: "status", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, align: "end" }
  ];

  get items() {
    return storeSupervisiLimbah.items;
  }

  get loading() {
    return storeSupervisiLimbah.loading;
  }

  get meta() {
    return storeSupervisiLimbah.meta;
  }

  get canCreate() {
    return userModule.hasPrivilege("supervisi_limbah", "create");
  }

  get canUpdate() {
    return userModule.hasPrivilege("supervisi_limbah", "update");
  }

  get tanggalDariDate(): Date | null {
    return composeDate(this.filter.tanggal_dari);
  }
  set tanggalDariDate(val: Date | null) {
    this.filter.tanggal_dari = toDateString(val) || "";
  }

  get tanggalSampaiDate(): Date | null {
    return composeDate(this.filter.tanggal_sampai);
  }
  set tanggalSampaiDate(val: Date | null) {
    this.filter.tanggal_sampai = toDateString(val) || "";
  }

  @Watch("pagination", { deep: true })
  onPagination() {
    this.fetch();
  }

  fetch() {
    const params: SupervisiLimbahListFilter = {
      page: this.pagination.page,
      per_page: this.pagination.itemsPerPage
    };
    if (this.filter.tanggal_dari) params.tanggal_dari = this.filter.tanggal_dari;
    if (this.filter.tanggal_sampai) params.tanggal_sampai = this.filter.tanggal_sampai;
    if (this.filter.signed !== null && this.filter.signed !== undefined) {
      params.signed = this.filter.signed;
    }
    storeSupervisiLimbah.fetchList(params);
  }

  applyFilter() {
    if (this.pagination.page !== 1) {
      this.pagination.page = 1;
      return;
    }
    this.fetch();
  }

  resetFilter() {
    this.filter = { tanggal_dari: "", tanggal_sampai: "", signed: null };
    this.applyFilter();
  }

  koordinatorName(item: SupervisiLimbah) {
    if (item.kepala_unit && item.kepala_unit.nama) return item.kepala_unit.nama;
    return item.kepala_unit_nama_manual || "-";
  }

  canDelete(item: SupervisiLimbah) {
    return this.canUpdate && !item.signed_supervisor && !item.signed_kepala_unit;
  }

  async confirmDelete(item: SupervisiLimbah) {
    if (!confirm(`Hapus draft supervisi ${item.nomor_formulir || ""}?`)) return;
    await SupervisiLimbahSvc.destroy(item.id);
    appModule.sendSuccessNotice("Draft supervisi berhasil dihapus");
    this.fetch();
  }

  createNew() {
    this.$router.push({ name: "supervisi-limbah-form", params: { id: "baru" } });
  }

  openEdit(id: number) {
    this.$router.push({ name: "supervisi-limbah-form", params: { id: String(id) } });
  }

  printPdf(id: number) {
    SupervisiLimbahSvc.printPdf(id);
  }

  formatDate(d: string) {
    if (!d) return "-";
    const [y, m, day] = d.split("-");
    return `${day}-${m}-${y}`;
  }
}
